module.exports = __webpack_public_path__ + "static/media/unlock-alt.29dee98c.svg";